export namespace CustomerServerAPI {
  // provision states
  export const ADAPTIVA_CDN_STATUS_NOT_PROVISIONED = 0;

  export const ADAPTIVA_CDN_STATUS_PROVISION_REQUESTED = 1;

  export const ADAPTIVA_CDN_STATUS_OPERATION_IN_PROGRESS = 2;

  export const ADAPTIVA_CDN_STATUS_PROVISIONED_ENABLED = 3;

  export const ADAPTIVA_CDN_STATUS_PROVISIONED_DISABLE_REQUESTED = 4;

  export const ADAPTIVA_CDN_STATUS_PROVISIONED_DISABLED = 5;

  export const ADAPTIVA_CDN_STATUS_PROVISIONED_DISABLED_ENABLE_REQUESTED = 6;

  export const ADAPTIVA_CDN_STATUS_PROVISIONED_UNPROVISION_REQUESTED = 7;

  // provision task status
  export const TASK_STATUS_NOT_STARTED = 0;

  export const TASK_STATUS_IN_PROGRESS = 1;

  export const TASK_STATUS_COMPLETED = 2;

  export const TASK_STATUS_FAILED = 3;

  export const getFailedAtTask = (_server: any): string => {
    const _provisioningStatuses = [
      ['provisionStorageTaskStatus', 'Storage provision'],
      ['provisionCdnTaskStatus', 'CDN provision'],
      ['provisionDnsTaskStatus', 'DNS provision']
    ];
    for (const _status of _provisioningStatuses) {
      if (_server[_status[0]] === TASK_STATUS_FAILED) {
        return _status[1];
      }
    }
    return null;
  };

  export const toCDNStatusString = (_status: number): string => {
    if (isNaN(_status)) {
      return 'Invalid status';
    }
    switch (_status) {
      case ADAPTIVA_CDN_STATUS_NOT_PROVISIONED:
        return 'Unprovisioned';
      case ADAPTIVA_CDN_STATUS_PROVISION_REQUESTED:
        return 'Provision requested';
      case ADAPTIVA_CDN_STATUS_OPERATION_IN_PROGRESS:
        return 'Operation in progress';
      case ADAPTIVA_CDN_STATUS_PROVISIONED_ENABLED:
        return 'Enabled';
      case ADAPTIVA_CDN_STATUS_PROVISIONED_DISABLE_REQUESTED:
        return 'Disabled requested';
      case ADAPTIVA_CDN_STATUS_PROVISIONED_DISABLED:
        return 'Disabled';
      case ADAPTIVA_CDN_STATUS_PROVISIONED_DISABLED_ENABLE_REQUESTED:
        return 'Enabled requested';
      case ADAPTIVA_CDN_STATUS_PROVISIONED_UNPROVISION_REQUESTED:
        return 'Unprovision requested';
      default:
        return 'Unknown status';
    }
  };

  export const toCDNStatusCode = (_status: string): number => {
    if (!_status) {
      return -1;
    }
    switch (_status.toLowerCase()) {
      case 'unprovisioned':
        return ADAPTIVA_CDN_STATUS_NOT_PROVISIONED;
      case 'provision requested':
        return ADAPTIVA_CDN_STATUS_PROVISION_REQUESTED;
      case 'operation in progress':
        return ADAPTIVA_CDN_STATUS_OPERATION_IN_PROGRESS;
      case 'enabled':
        return ADAPTIVA_CDN_STATUS_PROVISIONED_ENABLED;
      case 'disabled requested':
        return ADAPTIVA_CDN_STATUS_PROVISIONED_DISABLE_REQUESTED;
      case 'disabled':
        return ADAPTIVA_CDN_STATUS_PROVISIONED_DISABLED;
      case 'enabled requested':
        return ADAPTIVA_CDN_STATUS_PROVISIONED_DISABLED_ENABLE_REQUESTED;
      case 'unprovision requested':
        return ADAPTIVA_CDN_STATUS_PROVISIONED_UNPROVISION_REQUESTED;
      default:
        return -1;
    }
  };

  export const getFailureMessage = (_server: any): string => {
    const _failedAt = getFailedAtTask(_server) ?
      'Failed at ' + getFailedAtTask(_server) : '';
    // no error message
    if (!_server.taskFailureReason && !_failedAt) {
      return null;
    }
    // no taskFailureReason, but error code
    if (!_server.taskFailureReason) {
      return _failedAt;
    }
    // no failure code, but taskFailureReason exists
    if (!_failedAt) {
      return _server.taskFailureReason;
    }
    // we have everything, concatenate string
    return _failedAt + ' - ' + _server.taskFailureReason;
  };


}
